import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

export const ParkCallMenuStyleValues = {
  containerWidth: '18.75rem',
  containerWidthPopup: '12.75rem',
}

const parkCallMenuParts = ['headerContainer', 'headerText'] as const

const helpers = createMultiStyleConfigHelpers(parkCallMenuParts)
export const ParkCallMenuStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    headerContainer: {
      width: 'full',
      paddingY: '0.5rem',
      paddingX: '0.75rem',
      borderRadius: '0.5rem',
      alignItems: 'center',
    },
    headerText: {
      userSelect: 'none',
      ...textStyles[textStyleKeys.Body3_Bold],
    },
  },
})

export const useParkCallMenuStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ParkCallMenuStyle, props) as MultiStyleType<
    typeof parkCallMenuParts
  >
}
